import { motion } from "framer-motion";
import { ScanLine, Globe, Ruler } from "lucide-react";

const steps = [
  {
    icon: ScanLine,
    num: "01",
    title: "Scan once",
    body: "Create your FitID in seconds. Your fit profile lives with you, not the store.",
  },
  {
    icon: Globe,
    num: "02",
    title: "Use everywhere",
    body: "Works seamlessly across shops. One identity, every checkout, every brand.",
  },
  {
    icon: Ruler,
    num: "03",
    title: "Get your size instantly",
    body: "Accurate recommendations, zero guesswork. Calibrated per brand, per fit.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-14 md:mb-20">
          <div className="md:col-span-4">
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              <span className="h-px w-8 bg-black/40" />
              How it works
            </div>
          </div>
          <h2
            data-testid="how-headline"
            className="md:col-span-8 text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] font-medium leading-[1.02]"
          >
            Three steps. <span className="text-neutral-400">Then invisible.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`how-card-${i + 1}`}
              className="group relative glass-card rounded-2xl p-7 hover:-translate-y-1 transition-all duration-500"
            >
              <div className="flex items-start justify-between">
                <div className="h-11 w-11 rounded-xl border border-black/10 bg-white grid place-items-center">
                  <s.icon className="h-5 w-5 text-[#0A0A0A]" strokeWidth={1.5} />
                </div>
                <span className="text-[11px] tracking-[0.22em] text-neutral-400">
                  {s.num}
                </span>
              </div>
              <h3 className="mt-8 text-2xl tracking-tight font-medium">{s.title}</h3>
              <p className="mt-2 text-[15px] text-neutral-600 leading-relaxed">{s.body}</p>
              <div className="mt-8 h-px w-10 bg-black/10 group-hover:w-20 transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
